import { render, staticRenderFns } from "./LoginView.vue?vue&type=template&id=bb78c9b6&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"
import style0 from "./LoginView.vue?vue&type=style&index=0&id=bb78c9b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb78c9b6",
  null
  
)

export default component.exports